import React, { useState } from "react";
import ImgQuiz from '../assets/images/LP-arabe/quiz/quiz.png';
import ImgQuiz2 from '../assets/images/LP-arabe/quiz/quiz-2.png';
import BgQuiz from '../assets/images/LP-arabe/quiz/bg-quiz.png';

const questions = [
  {
    question: "Qual é o livro sagrado do Islã?",
    options: ["Evangelho", "Torá", "Alcorão"],
    answer: "Alcorão",
  },
  {
    question: "O Islam está construído sobre quantos pilares?",
    options: ["3", "5", "7"],
    answer: "5",
  },
  {
    question: "Qual é o idioma oficial da maioria dos países árabes?",
    options: ["Persa", "Árabe", "Turco"],
    answer: "Árabe",
  },
];

const ModalQuiz = ({ open, onClose }) => {
  const [step, setStep] = useState(-1); 
  const [score, setScore] = useState(0);
  const [selected, setSelected] = useState(null);
  const [answers, setAnswers] = useState([]);
  const [showAnswer, setShowAnswer] = useState(false); // ✅ mostra resposta

  const startQuiz = () => setStep(0);

  const handleNext = () => {
    if (!selected) return;

    const correct = selected === questions[step].answer;
    if (correct) setScore(score + 1);

    setAnswers([
      ...answers,
      {
        question: questions[step].question,
        selected,
        correctAnswer: questions[step].answer,
        isCorrect: correct
      }
    ]);

    // reset seleção e resposta
    setSelected(null);
    setShowAnswer(false);

    if (step + 1 < questions.length) {
      setStep(step + 1);
    } else {
      setStep("finished");
    }
  };

  const restartQuiz = () => {
    setStep(-1);
    setScore(0);
    setSelected(null);
    setAnswers([]);
    setShowAnswer(false);
  };

  if (!open) return null;

  return (
    <div className="modal-bg">
      <div
        className={`modal-box ${step === -1 ? "welcome-bg" : "quiz-bg"}`}
        style={
          step === -1
            ? { backgroundImage: `url(${BgQuiz})`, backgroundSize: "cover", backgroundPosition: "center" }
            : {}
        }
      >
        <button className="close-btn" onClick={onClose}>✕</button>

        {/* Tela inicial */}
        {step === -1 && (
          <div className="center">
            <img src={ImgQuiz} alt="" />
            <h2>Quanto você conhece da <span>cultura árabe?</span></h2>
            <p>Explore curiosidades, costumes, tradições e aspectos históricos da cultura árabe em um quiz leve e educativo.</p>

            <button className="btn-primary" onClick={startQuiz}>
              Descubra
            </button>
          </div>
        )}

        {/* Perguntas */}
        {step >= 0 && step !== "finished" && (
          <div className="center">
            <img src={ImgQuiz2} alt="" style={{ width: '100%', maxWidth: 434, marginBottom: 24 }} />

            <h3>{questions[step].question}</h3>

            {questions[step].options.map((opt) => (
              <button
                key={opt}
                className={`option-btn ${selected === opt ? "active" : ""}`}
                onClick={() => {
                  setSelected(opt);
                  setShowAnswer(true); // ✅ exibe resposta ao clicar
                }}
                disabled={showAnswer} // ✅ trava opções após escolher
              >
                {opt}
              </button>
            ))}

            {/* ✅ Mensagem de acerto/erro */}
            {showAnswer && selected && (
              <div style={{ marginTop: 12 }}>
                {selected === questions[step].answer ? (
                  <p style={{ color: "green", fontWeight: "bold" }}>✅ Você acertou!</p>
                ) : (
                  <p style={{ color: "red", fontWeight: "bold" }}>
                    ❌ Resposta correta: {questions[step].answer}
                  </p>
                )}
              </div>
            )}

            <button
              className="btn-primary"
              onClick={handleNext}
              disabled={!selected}
            >
              Próxima
            </button>
          </div>
        )}

        {/* Final */}
        {step === "finished" && (
          <div className="center">
            <h2>Resultado 🎉</h2>

            <p>
              Você acertou <strong>{score}</strong> de <strong>{questions.length}</strong> 
              {" "}({Math.round((score / questions.length) * 100)}%)
            </p>

            <hr />

            <h4>Resumo:</h4>
            {answers.map((ans, i) => (
              <div key={i} className="answer-row">
                <strong>{i + 1}. {ans.question}</strong><br />
                Resposta: {ans.correctAnswer}<br/>
                {ans.isCorrect ? (
                  <span style={{ color: "green" }}>Você acertou ({ans.selected})</span>
                ) : (
                  <span style={{ color: "red" }}>Você errou ({ans.selected})</span>
                )}
              </div>
            ))}

            <button className="btn-primary" onClick={restartQuiz}>
              Fazer novamente
            </button>
          </div>
        )}
      </div>

      {/* Styles */}

<style>{`
.modal-bg {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}
.modal-box {
  width: 740px;
  padding: 40px;
  border-radius: 14px;
  text-align: center;
  position: relative;
  transition: background .4s ease;
}
.welcome-bg {
  background-color: #3C5F3F;
  color: #FFF;
}
.quiz-bg {
  background: #F7FAF8;
  color: #000;
}
.close-btn {
  position: absolute;
  top: 15px; right: 15px;
  background: transparent;
  font-size: 22px;
  border: none;
  cursor: pointer;
  color: inherit;
}
.center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
h3 {
  color: #636363;
  text-align: center;
  font-family: Montserrat;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
}
h2 {
  color: #FFF;
  text-align: center;
  font-family: Montserrat;
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  margin: 20px 0 10px;
  width: 100%;
  max-width: 510px;
}
h2 span { 
  color: #F26F33;
  font-weight: 600;
}
p {
  color: #FFF;
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 20px;
  width: 100%;
  max-width: 550px;
}
.btn-primary {
  background: #F26F33;
  border: none;
  padding: 12px 0;
  width: 100%;
  max-width: 300px;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px;
}
.btn-primary:hover {
  background: #CF4201;
}
.btn-primary:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.option-btn {
  width: 100%;
  max-width: 320px;
  margin: 6px auto;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
  cursor: pointer;
  background: transparent;
  color: #4B4B4A;
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.option-btn.active {
  background: #FFDDBF;
  border-color: #F26F33;
}
.answer-row {
  text-align: left;
  margin-bottom: 12px;
}
.answer-row strong {
  font-size: 22px;
}
`}</style>

    </div>
  );
};

export default ModalQuiz;
